

<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">View All Details</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
</div>
<div>
    <div *ngIf="data2?.cctvDetails">
        <div class="name">
            {{data2?.cctvDetails.buildingName}}
        </div>
        <mat-divider></mat-divider>
        <div>
            <div class="campus_dtl">
                <h3 class="ip-addres">IP Address</h3>
                <h3 class="ip-number">{{data2?.cctvDetails.ipAddress}}</h3>
            </div>
            <div class="color_1">
                <div class="campus_dtl">
                    <h3 class="dvr-model">DVR Model Number</h3>
                    <h3 class="dvr-number">
                        {{data2?.cctvDetails.dvrModelNumber}}</h3>
                </div>
            </div>
            <div class="campus_dtl">
                <h3 class="serial">Serial Number</h3>
                <h3 class="serial-number">
                    {{data2?.cctvDetails.serialNumber}}</h3>
            </div>
            <div class="color_1">
                <div class="campus_dtl">
                    <h3 class="rtsp">RTSP Port No</h3>
                    <h3 class="rtsp-no">{{data2?.cctvDetails.rtspPortNo}}
                    </h3>
                </div>
            </div>
            <div class="campus_dtl">
                <h3 class="channel">Max No Of Channels
                </h3>
                <h3 class="channel-number">
                    {{data2?.cctvDetails.maxNoOfChannels}}</h3>
            </div>
            <div class="color_1">
                <div class="campus_dtl">
                    <h3 class="cameras-install">Total Cameras Installed</h3>
                    <h3 class="camera-number">
                        {{data2?.cctvDetails.totalCamerasInstalled}}</h3>
                </div>
            </div>
            <div class="campus_dtl">
                <h3 class="dvr-working">DVR Present Working Status
                </h3>
                <h3 class="dvr-status">
                    {{data2?.cctvDetails.dvrPresentWorkingStatus}}</h3>
            </div>
            <div class="color_1">
                <div class="campus_dtl">
                    <h3 class="remark">Remarks</h3>
                    <h3 class="remark-video">{{data2?.cctvDetails.remarks}}
                    </h3>
                </div>
            </div>
            <div class="campus_dtl">
                <h3 class="dvr-working">Connected
                </h3>
                <h3 class="dvr-status">
                    {{data2?.cctvViewallDetails.totalConnected}}</h3>
            </div>
            <div class="color_1">
                <div class="campus_dtl">
                    <h3 class="remark">Not Connected</h3>
                    <h3 class="remark-video">{{data2?.cctvViewallDetails.totalNotConnected
                    }}
                    </h3>
                </div>
            </div>
            <div class="campus_dtl">
                <h3 class="dvr-working">Streaming
                </h3>
                <h3 class="dvr-status">
                    {{data2?.cctvViewallDetails.totalVideoStreaming}}</h3>
            </div>
            <div class="color_1">
                <div class="campus_dtl">
                    <h3 class="remark">Not Streaming</h3>
                    <h3 class="remark-video">{{data2?.cctvViewallDetails.totalVideoNotStreaming}}
                    </h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mt-2 pl-3 pb-3">
    <button class="btn btn-primary" (click)="onNoClick()">Close</button>
</div>



